@if (hasBox()) {
  <rt-box layout-vertical>
    <ng-container [ngTemplateOutlet]="content" />
  </rt-box>
} @else {
  <ng-container [ngTemplateOutlet]="content" />
}

<ng-template #content>
  <rt-form-field>
    <div class="comment-field__label">
      {{ 'app.evaluation_panel.add_comment' | translate }}
    </div>

    @if (useProsemirror) {
      <div rtWysiwygContextTooltipContainer>
        <rt-wysiwyg
          prosemirrorGroupedConfig
          [config]="ProsemirrorGroupedConfig"
          [formControl]="jsonControl()"
          [withMinHeight]="true"
          [placeholder]="'app.evaluation_panel.add_comment_placeholder' | translate"
        />
      </div>
    } @else {
      <rt-redactor
        [formControl]="control()"
        [config]="redactorConfig"
        [placeholder]="'app.evaluation_panel.add_comment_placeholder' | translate"
        [borderRadius]="'both'"
      />
    }
  </rt-form-field>
</ng-template>
